<div class="py-4">
<h2 class="font-medium text-xl px-8">{{dialogData.title}}</h2>
<mat-dialog-content class="my-4 dialog-body">
  <div [innerHTML]="htmlContent"></div>
</mat-dialog-content>
<div align="end" class="mx-6">
  <button mat-button mat-dialog-close *ngIf="dialogData.button.discard" class="font-medium mr-4">
    {{dialogData.button.discard}}
  </button>
  <button mat-button [mat-dialog-close]="true" [color]="dialogData.button.color" class="font-medium" cdkFocusInitial>
    {{dialogData.button.proceed}}</button>
</div>
</div>
